<template>
  <div class="system-builder__select-remote--section">

    <div class="system-builder__main-remotes--wrapper">
      <remoteItem v-for="(remote, index) in sharedState.filteredRemotes"
                  :remoteKey="index" :id="remote.ID">
        <div slot="remote-image" v-if="remote.images">
          <img :src="remote.images.image.url" :alt="remote.images.image.alt">
        </div>
        <div slot="remote-description">
          <h3>{{ remote.post_title }}</h3>
          <ul class="product-available-features">
            <li v-for="(feature, featureIndex) in remote.remote_features" v-html="feature"
                v-if="featureIndex < numberFeaturesToShow">
            </li>
          </ul>
        </div>
      </remoteItem>
    </div>

  </div>
</template>

<script>
  import store from '../../store'
  import router from '../../router'
  import remoteItem from '../reusable/RemoteItem.vue'
  import featureItem from '../reusable/featureItem.vue'
  import $ from 'jquery'

  export default {
    components: {remoteItem, featureItem},
    name: 'selectRemote',
    data () {
      return {
        sharedState: store.state,
        numberFeaturesToShow: 3
      }
    },
    methods: {
      objectLength: function (object) {
        var length = 0
        for (var key in object) {
          if (object.hasOwnProperty(key)) {
            ++length
          }
        }
        return length
      },
      containsObject: function (obj, list) {
        var i
        for (i = 0; i < list.length; i++) {
          if (list[i] === obj) {
            return true
          }
        }

        return false
      },
      retrieveAccessories: function () {
        var ajaxUrl = 'https://' + window.location.hostname + '/wp-admin/admin-ajax.php'

        $.ajax({
          url: ajaxUrl,
          type: 'POST',
          dataType: 'text',
          data: {
            action: 'system-builder-get-accessories'
          },
          cache: false,
          success: function (response) {
            var jsonObj = JSON.parse(response)
            store.holdAccessories(jsonObj.accessories)
            return false
          }
        })
      }
    },
    mounted: function () {
      if (this.sharedState.accessories === null) {
        this.retrieveAccessories()
      }
      if (store.state.vehicleObject.year === 'Vehicle Year') {
        store.updateCurrentStateRoute('selectVehicle')
        router.push({name: 'selectVehicle'})
        return false
      } else if (store.state.selectedSystemCategory === '') {
        store.updateCurrentStateRoute('selectSystem')
        router.push({name: 'selectSystem'})
        return false
      } else if (store.state.selectedCommunication === '') {
        store.updateCurrentStateRoute('selectCommunicationType')
        router.push({name: 'selectCommunicationType'})
        return false
      }
    },
    beforeCreate: function () {
      store.getLocalStorage()
    }
  }
</script>



// WEBPACK FOOTER //
// SelectRemote.vue?a3069cee